import gql from 'graphql-tag';

const ADD_VIEW = gql`
  mutation($input: ListViewInput) {
    addView(input: $input) {
      id
      name
      module
      viewCondition
      shared
    }
  }
`;

const UPDATE_VIEW = gql`
  mutation($id: ID!, $input: ListViewInput!) {
    updateView(id: $id, input: $input) {
      id
      name
      displayIcon
      module
      viewCondition
      shared
      customView
    }
  }
`;

const DELETE_VIEW = gql`
  mutation($id: ID!, $input: ListViewInput!) {
    deleteView(id: $id, input: $input)
  }
`;

export { ADD_VIEW, UPDATE_VIEW, DELETE_VIEW };
